import { Flex, Heading, ToggleForm } from '@npco/zeller-design-system'
import { Field, useFormikContext } from 'formik'

import { translate } from 'utils/translations'
import { CustomerDetailsForm } from 'types/customers'
import { Description } from 'layouts'

interface EnableInvoicesProps {
  isAdmin?: boolean
}

export const EnableInvoices = ({ isAdmin }: EnableInvoicesProps) => {
  const { values } = useFormikContext<CustomerDetailsForm>()
  return (
    <>
      <Flex justifyContent="space-between">
        <Heading.H3 mb="24px">
          {translate('page.settings.users.invoices.settingsTitle')}
        </Heading.H3>
        <Field
          component={ToggleForm}
          name="allowZellerInvoices"
          value={values.allowZellerInvoices}
          isDisabled={isAdmin}
        />
      </Flex>
      <Description>
        {isAdmin
          ? translate('page.settings.users.invoices.descriptionAdmin')
          : translate('page.settings.users.invoices.descriptionManager')}
      </Description>
    </>
  )
}
